//const API_BASE_URL = 'https://fibretelecom.peachpreview.co.uk/api';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`
  };
};

// Helper function to handle unauthorized responses
const handleUnauthorized = (response) => {
  if (response.status === 401) {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
    throw new Error('Authentication required');
  }
};

export const saveMechanicData = async (data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/addmechanics`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });

    handleUnauthorized(response);

    if (!response.ok) {
      throw new Error("Failed to save data");
    }

    return await response.json();
  } catch (error) {
    console.error("Error saving mechanic data:", error);
    throw error;
  }
};

export const fetchMechanicsData = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/mechanics`, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    handleUnauthorized(response);

    if (!response.ok) {
      throw new Error("Failed to fetch mechanics");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching mechanics:", error);
    throw error;
  }
};

export const fetchMechanicServices = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/mechanics/services`, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    handleUnauthorized(response);
    
    if (!response.ok) {
      throw new Error("Failed to fetch services");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching services:", error);
    throw error;
  }
};

export const fetchCommission = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/mechanic/commission`, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    handleUnauthorized(response);

    if (!response.ok) {
      throw new Error("Failed to fetch commission");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching commission:", error);
    throw error;
  }
};
export const getIncentivesData = async () => {
  try {
   
    const response = await fetch(`${API_BASE_URL}/mechanics/incentives`, { // Use API_BASE_URL here
      method: 'GET',
      headers: getAuthHeaders(),
    });
    
   
    
    handleUnauthorized(response);
    
    if (!response.ok) {
      throw new Error('Failed to fetch incentives data');
    }
    
    const data = await response.json();
    //console.log("📦 API Response data:", data);
    return data;
  } catch (error) {
    console.error('❌ Error fetching incentives data:', error);
    throw error;
  }
};